import { OktaAuth } from '@okta/okta-auth-js';
import React from 'react';
import { IdpType, AppOIDCConfig } from './types';

interface AppOktaContextState {
  setOktaTenant: (value: IdpType) => void;
  oktaTenant: IdpType;
  oktaAuthService?: OktaAuth;
  ascendSsarOIDCConfig?: AppOIDCConfig;
}

const AppOktaContext = React.createContext<AppOktaContextState>({
  setOktaTenant(_b: IdpType) {
    // Default implementation
  },
  oktaTenant: IdpType.OktaB2E,
});

export const AppOktaProvider = AppOktaContext.Provider;

export const useAppOKtaContext = (): AppOktaContextState => React.useContext(AppOktaContext);